import React from "react";
import {
  AdminSectionTitle,
  AdminMainText,
  AdminSupportingText,
  AdminMetadataText,
} from "../../AdminDashboard/shared/adminUx";

const NotificationsLayout = () => {
  const Notificationdata = [
    {
      heading: "Account & Security",
      description: "Login alerts, password changes, security notices",
      emailEnabled: true,
      smsEnabled: true,
      pushEnabled: false,
    },
    {
      heading: "Profile Changes",
      description: "Notifications when profile details are updated",
      emailEnabled: false,
      smsEnabled: true,
      pushEnabled: true,
    },
    {
      heading: "Customer Messages",
      description: "New messages from customers",
      emailEnabled: true,
      smsEnabled: false,
      pushEnabled: true,
    },
    {
      heading: "Customer Reviews",
      description: "Alerts for new customer reviews",
      emailEnabled: false,
      smsEnabled: false,
      pushEnabled: true,
    },
    {
      heading: "Billing & Subscription Reminders",
      description: "Payment and renewal alerts",
      emailEnabled: true,
      smsEnabled: true,
      pushEnabled: false,
      emailLocked: true,
      specialNote: "Email must always stay On. SMS optional.",
    },
    {
      heading: "Compliance Notices",
      description: "Legal or regulatory changes",
      emailEnabled: true,
      smsEnabled: true,
      pushEnabled: true,
    },
    {
      heading: "Platform Announcements",
      description: "Policy updates and system news",
      emailEnabled: false,
      smsEnabled: true,
      pushEnabled: false,
    },
    {
      heading: "Data Privacy Updates",
      description: "Changes to privacy rules or consent requirements",
      emailEnabled: true,
      smsEnabled: false,
      pushEnabled: true,
    },
  ];

  return (
    <div className="tp-container-narrow mx-auto w-full">
      {Notificationdata.map((item) => (
        <div
          key={item.heading}
          className="flex items-start justify-between gap-x-5 mb-4 bg-mistygray border border-mistygray rounded-xl p-4"
        >
          <div className="flex-1">
            <AdminSectionTitle className="text-offblack">{item.heading}</AdminSectionTitle>
            <AdminMainText className="mt-2 text-offblack block">{item.description}</AdminMainText>

            <div className="flex flex-wrap gap-6 mt-3">
              {[
                {
                  id: "email",
                  label: item.emailLocked ? "Email (locked On)" : "Email",
                  checked: item.emailEnabled,
                  locked: item.emailLocked,
                },
                { id: "sms", label: "SMS", checked: item.smsEnabled },
                { id: "push", label: "Push", checked: item.pushEnabled },
              ].map((opt) => (
                <label key={opt.id} className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    defaultChecked={opt.checked}
                    disabled={opt.locked}
                    className="size-4 rounded border-mediumgray text-primaryblue focus:ring-primaryblue disabled:opacity-60"
                  />
                  <AdminMetadataText className={opt.locked ? "text-mediumgray" : "text-offblack"}>
                    {opt.label}
                  </AdminMetadataText>
                </label>
              ))}
            </div>

            {item.specialNote ? (
              <AdminSupportingText className="mt-2 text-mediumgray block">
                {item.specialNote}
              </AdminSupportingText>
            ) : null}
          </div>
          <label className="relative inline-flex shrink-0 cursor-pointer self-start mt-0.5">
            <input type="checkbox" className="sr-only peer" defaultChecked />
            <div className="relative w-9 h-5 bg-lightgray rounded-full peer-checked:bg-primaryblue after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:h-4 after:w-4 after:rounded-full after:bg-white after:transition-all peer-checked:after:translate-x-4" />
          </label>
        </div>
      ))}
    </div>
  );
};

export default NotificationsLayout;
